import MessageBubbleAnimationDropdown from "../message_bubble/MessageBubbleAnimationDropdown";
import { MessageBubbleAnimation } from "../../../models/interactions/MessageBubble";

export default function ConversationAnimationDropdown(props: {
  selectedAnimation: MessageBubbleAnimation;
  setSelectedAnimation: (animation: MessageBubbleAnimation) => void;
}) {
  return (
    <MessageBubbleAnimationDropdown
      selectedAnimation={props.selectedAnimation}
      onClick={props.setSelectedAnimation}
      variant="conversation"
    />
  );
}
